import * as Net from 'util/Net';

import {CreateRoutinePayload, UpdateRoutinePayload} from './RoutineTypes';

export function createRoutine(payload: CreateRoutinePayload): Promise<{id: string}> {
  return Net.postJSONPromise({
    url: '/1/api/llm/routines',
    data: {
      name: payload.name,
      description: payload.description,
      messageBlocks: payload.messageBlocks,
      agentType: payload.agentType,
      triggerType: payload.triggerType,
      triggerConfig: payload.triggerConfig,
    },
  });
}

export function updateRoutine(id: string, payload: UpdateRoutinePayload): Promise<{id: string}> {
  return Net.patchJSONPromise({
    url: `/1/api/llm/routines/${id}`,
    data: payload,
  });
}

export function pauseRoutine(id: string): Promise<{id: string}> {
  return Net.postJSONPromise({
    url: `/1/api/llm/routines/${id}:pause`,
    data: {},
  });
}

export function resumeRoutine(id: string): Promise<{id: string}> {
  return Net.postJSONPromise({
    url: `/1/api/llm/routines/${id}:resume`,
    data: {},
  });
}

export function runRoutine(id: string): Promise<{chatSessionId: string}> {
  return Net.postJSONPromise({
    url: `/1/api/llm/routines/${id}:run`,
    data: {},
  });
}

export function archiveRoutine(id: string, reason: string): Promise<{id: string}> {
  return Net.postJSONPromise({
    url: `/1/api/llm/routines/${id}:archive`,
    data: {reason},
  });
}
